import React from 'react';
import { Button, Input } from '@wix/design-system';
import { Search } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/wix-i18n-config';
import { buildConnectDomainUrl } from 'utils/dashboard';
import styles from '../PostPurchaseStep.scss';

interface DomainRowProps {
  buttonLabel: string;
  metaSiteId: string | null;
  onConnectClick?: (domain: string) => void;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export function DomainRow({ buttonLabel, metaSiteId, onConnectClick, placeholder, value, onChange }: DomainRowProps) {
  const { t } = useTranslation();
  const domainName = value.trim() || placeholder.trim();
  const connectDomainUrl = metaSiteId && domainName ? buildConnectDomainUrl(metaSiteId, domainName) : undefined;

  return (
    <div className={styles.postPurchaseDomainRow}>
      <Input
        className={styles.postPurchaseDomainInput}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onClear={() => onChange('')}
        placeholder={placeholder}
        ariaLabel={t('post_purchase.domain.search_aria')}
        clearButton
        prefix={
          <Input.IconAffix>
            <Search />
          </Input.IconAffix>
        }
        size="medium"
      />
      <Button
        as="a"
        href={connectDomainUrl || '#'}
        target="_blank"
        rel="noopener noreferrer"
        aria-disabled={!connectDomainUrl}
        onClick={(event) => {
          if (!connectDomainUrl) {
            event.preventDefault();
            return;
          }

          onConnectClick?.(domainName);
        }}
        priority="primary"
        size="medium"
        skin="standard"
      >
        {buttonLabel}
      </Button>
    </div>
  );
}
